exports.components = {
  "component---src-4-templates-blog-details-js": () => import("./../../../src/4_templates/blogDetails.js" /* webpackChunkName: "component---src-4-templates-blog-details-js" */),
  "component---src-4-templates-work-details-js": () => import("./../../../src/4_templates/workDetails.js" /* webpackChunkName: "component---src-4-templates-work-details-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

